import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import qs from 'query-string';
import * as User from 'rev.sdk.js/Actions/User';
import * as AppActions from '../AppActions';

// NOTICE:
// we use hash instead of query param here, so that we don't need to
// deal with different CDN's behaviors
function getHashParams() {
  if (typeof window !== 'undefined') {
    const hash = window.location?.hash;
    if (hash) {
      return qs.parse(hash.replace('#', '?'));
    }
  }
  return {};
}

function MobileCheckoutLayout(props) {
  const [user] = useOutlet('user');
  const {style = {}} = props;
  const {refresh} = getHashParams();

  React.useEffect(() => {
    async function login() {
      AppActions.setLoading(true);
      try {
        await User.autoLogin({refresh});
      } catch (ex) {
        alert('Fail to login! Please reload your app');
      }
      AppActions.setLoading(false);
    }

    if (refresh) {
      login();
    }
  }, [refresh]);

  if (!user) {
    return (
      <Wrapper style={{...style}}>
        <div className="content">Loading User Info...</div>
      </Wrapper>
    );
  }

  return (
    <Wrapper style={{...style}}>
      <div className="content">{props.children}</div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 0px;

  & > .content {
    max-width: var(--contentMaxWidth);
    min-height: var(--contentMinHeight);
    margin: 0 auto;
    padding: var(--basePadding);
  }
`;

export default MobileCheckoutLayout;
